import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from '@store/store';

interface IDownloadRendimentosState {
    download: string | null;
    downloading: boolean;
    downloadError: string | null;
}

const initialState: IDownloadRendimentosState = {
    download: null,
    downloadError: null,
    downloading: false
};

export const downloadRendimentosSlice = createSlice({
    name: 'downloadRendimentos',
    initialState,
    reducers: {
        download_rendimentos_fetching: (state) => {
            state.downloading = true;
            state.download = '';
            state.downloadError = null;
        },
        download_rendimentos_success: (state, action: PayloadAction<string>) => {
            state.download = action.payload;
            state.downloading = false;
            state.downloadError = null;
        },
        download_rendimentos_error: (state, action: PayloadAction<string>) => {
            state.downloadError = action.payload;
            state.downloading = false;
            state.download = null;
        }
    }
});

export const { download_rendimentos_fetching, download_rendimentos_success, download_rendimentos_error } = downloadRendimentosSlice.actions;

export const selectorDownloadRendimentos = (state: AppState) => state.downloadRendimentos;

export default downloadRendimentosSlice.reducer;
